import { CompositeTableTemplate, renderCellGrayZeros } from 'app/common/templates-next/table-template'

import { Allowance } from '../../../_common/useReportAllowances'
import { AllSchoolsAllowancesAndFoodModesDto } from '../../../_common/useReportAllSchoolsAllowancesAndFoodModesDto'
import { TotalsAllowancesAndFoodModesDto } from '../../../_common/useReportTotalsAllowancesAndFoodModesDto'
import { useByAllowancesAndFoodModesTableData } from './useByAllowancesAndFoodModesTableData'


type Props = {
  allowances: Array<Allowance>
  allSchoolsAllowancesAndFoodModesDto: AllSchoolsAllowancesAndFoodModesDto
  totalsAllowancesAndFoodModesDto: TotalsAllowancesAndFoodModesDto
}

export const ByAllowancesAndFoodModesTable = ({
  allowances,
  allSchoolsAllowancesAndFoodModesDto,
  totalsAllowancesAndFoodModesDto,
}: Props) => {
  const tableData = useByAllowancesAndFoodModesTableData({
    allowances,
    allSchoolsAllowancesAndFoodModesDto,
    totalsAllowancesAndFoodModesDto,
  })

  return (
    <CompositeTableTemplate
      data={tableData}
      renderCell={renderCellGrayZeros}
      renderFooterCell={renderCellGrayZeros}
    />
  )
}
